export const checkIsHrefValid = (url?: string): boolean => {
  return !!url && url !== 'http://' && url !== 'https://' && url !== '/';
};
